import { Link } from "react-router-dom";
import { ShieldAlert, ReceiptText, Landmark, Phone, MessageCircle, HeartHandshake } from "lucide-react";
import PageBanner from "../components/PageBanner";
import Seo from "../components/Seo";
import { Reveal, SectionLabel } from "../components/Motion";
import { useApp } from "../AppContext";
import { C, TRUST, UI, IMAGES } from "../content";

export default function Donate() {
  const { t, lang } = useApp();
  const wa = `https://wa.me/${TRUST.whatsapp}?text=${encodeURIComponent(UI.whatsapp_prefill[lang])}`;
  return (
    <div>
      <Seo title="Donations / Seva" description="Support annadan, temple upkeep and religious programmes at Sadguru Narayan Swami Math, Audumbar. Contact the Trust for contribution details; donations are tax-exempt under 80G." />
      <PageBanner label={lang === "mr" ? "सेवा" : "Seva"} titleObj={C.donate} subObj={C.donate} image={IMAGES.gurujiAshram} />

      <section className="py-16 lg:py-24 max-w-[1400px] mx-auto px-4 lg:px-8 grid lg:grid-cols-2 gap-12 items-start">
        <div className="space-y-6">
          <Reveal>
            <div className="rounded-3xl border border-earth-900/10 bg-white p-6 lg:p-8" data-testid="contribute-card">
              <SectionLabel>{lang === "mr" ? "योगदान कसे द्याल" : "How to Contribute"}</SectionLabel>
              <div className="flex items-center gap-3 mb-4"><HeartHandshake className="text-saffron-600" size={28} /><h2 className="font-serif-head text-3xl text-earth-900">{lang === "mr" ? "सेवेत सहभागी व्हा" : "Take Part in the Seva"}</h2></div>
              <p className="text-earth-800/85 text-lg leading-relaxed">
                {lang === "mr"
                  ? "देणगी देऊ इच्छिणाऱ्या भाविकांना ट्रस्टमार्फत वैयक्तिकरित्या देणगीचा तपशील / पेमेंट लिंक दिला जातो. कृपया खालील क्रमांकांवर संपर्क साधा."
                  : "Devotees wishing to contribute are provided the donation details / payment link personally by the Trust. Please get in touch using the numbers below."}
              </p>
              <div className="mt-6 flex flex-col sm:flex-row gap-3">
                <a href={`tel:${TRUST.phone_office.replace(/\s+/g, "")}`} data-testid="donate-call" className="inline-flex items-center justify-center gap-2 rounded-full bg-deepred-700 hover:bg-deepred-800 text-white px-6 py-3 font-semibold transition-all hover:-translate-y-0.5">
                  <Phone size={18} /> {TRUST.phone_office}
                </a>
                <a href={wa} target="_blank" rel="noreferrer" data-testid="donate-whatsapp" className="inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] hover:brightness-105 text-white px-6 py-3 font-semibold transition-all hover:-translate-y-0.5">
                  <MessageCircle size={18} /> {UI.whatsapp_help[lang]}
                </a>
              </div>
              <p className="mt-3 text-sm text-earth-600">{lang === "mr" ? "कार्यालयीन वेळेनंतर: " : "After office hours: "}{TRUST.phone_after}</p>
            </div>
          </Reveal>

          <Reveal delay={0.06}>
            <div className="rounded-3xl border border-earth-900/10 bg-sand-100 p-6 lg:p-8" data-testid="bank-card">
              <div className="flex items-center gap-3 mb-3"><Landmark className="text-deepred-700" /><h3 className="font-serif-head text-2xl text-earth-900">{lang === "mr" ? "बँक तपशील" : "Bank Transfer"}</h3></div>
              <p className="text-earth-800/85">{t(C.donate, "bank")}</p>
            </div>
          </Reveal>
        </div>

        <div className="space-y-6">
          <Reveal>
            <div className="rounded-3xl border border-earth-900/10 bg-white p-6 lg:p-8">
              <div className="flex items-center gap-3 mb-3"><ReceiptText className="text-saffron-600" /><h3 className="font-serif-head text-2xl text-earth-900">{lang === "mr" ? "पारदर्शकता" : "Transparency"}</h3></div>
              <p className="text-earth-800/85">{t(C.donate, "receipt")}</p>
              <p className="mt-3 text-deepred-700 font-semibold">{t(C.donate, "tax")}</p>
            </div>
          </Reveal>
          <Reveal delay={0.06}>
            <div className="rounded-3xl border-2 border-deepred-700/30 bg-deepred-700/5 p-6 lg:p-8" data-testid="fraud-notice">
              <div className="flex items-center gap-3 mb-3"><ShieldAlert className="text-deepred-700" /><h3 className="font-serif-head text-2xl text-deepred-800">{lang === "mr" ? "फसवणुकीबाबत सावधानता" : "Fraud Awareness"}</h3></div>
              <p className="text-earth-900/90 leading-relaxed">{t(C.donate, "fraud")}</p>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <Link to="/contact" data-testid="donate-contact-link" className="inline-flex items-center gap-2 text-saffron-700 font-semibold hover:text-saffron-600">
              {lang === "mr" ? "अधिक माहितीसाठी संपर्क करा →" : "Contact us for more details →"}
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
